import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { type ILink } from "src/interfaces";

import {
  generateManagementHomeLinks,
  type IManagementHomeLinksParams,
} from "../utils/generateManagementHomeLinks";

interface PermsSlice {
  perms: string[];
  yachtuser: boolean;
  reviewer: boolean;
  auditor: boolean;
  management: boolean;
  yachtAdmin: boolean;
  clientid: string | null;
  areChecklistsDisabled: boolean;
  clientAdmin: boolean;
  managementLinks: ILink[];
  isRestrictedToYacht: boolean;
  isRestrictedToOrg: boolean;
  hasFetchedPerms: boolean;
  rolename: string;
  medroles?: string[];
  fullName: string;
  usertype: number;
  isGenericAccount: boolean;
  nonMaritime: boolean;
}

const initialState: PermsSlice = {
  perms: [],
  yachtuser: false,
  reviewer: false,
  auditor: false,
  management: false,
  yachtAdmin: false,
  clientid: null,
  areChecklistsDisabled: false,
  clientAdmin: false,
  managementLinks: [],
  isRestrictedToYacht: false,
  isRestrictedToOrg: false,
  hasFetchedPerms: false,
  rolename: "",
  fullName: "",
  usertype: 0,
  isGenericAccount: false,
  nonMaritime: false,
};

export const permsSlice = createSlice({
  name: "permsSlice",
  initialState,

  reducers: {
    setPermsProperty: (
      state,
      action: PayloadAction<{ key: keyof PermsSlice; value: any }>,
    ) => {
      const { key, value } = action.payload;
      (state[key] as any) = value;
    },

    setUserType: (state, action: PayloadAction<number>) => {
      const usertype = action.payload;
      state.usertype = usertype;
      state.yachtuser = usertype !== 8 && usertype !== 9;
      state.yachtAdmin = usertype === 7;
      state.reviewer = usertype === 9;
      state.auditor = usertype === 8;
      state.management = usertype === 1;
      state.clientAdmin = usertype === 4 || usertype === 5;
    },

    setAreChecklistsDisabled: (state, action: PayloadAction<boolean>) => {
      state.areChecklistsDisabled = action.payload;
    },
    setIsRestrictedToYacht: (state, action: PayloadAction<boolean>) => {
      state.isRestrictedToYacht = action.payload;
    },
    setIsRestrictedToOrg: (state, action: PayloadAction<boolean>) => {
      state.isRestrictedToOrg = action.payload;
    },
    setHasFetchedPerms: (state, action: PayloadAction<boolean>) => {
      state.hasFetchedPerms = action.payload;
    },

    setManagementLinks: (
      state,
      action: PayloadAction<IManagementHomeLinksParams | undefined>,
    ) => {
      if (!action.payload) {
        state.managementLinks = [];
        return;
      }
      state.managementLinks = generateManagementHomeLinks(
        action.payload,
        state.clientAdmin,
      );
    },
  },
});

export const {
  setAreChecklistsDisabled,
  setManagementLinks,
  setIsRestrictedToYacht,
  setIsRestrictedToOrg,
  setUserType,
  setHasFetchedPerms,
  setPermsProperty,
} = permsSlice.actions;

export default permsSlice.reducer;
